export const MAX_BORROWER_UPLOAD_FILE_SIZE = 100 * 1024 * 1024; // 50mb (note: bucketAV has 2gb limit)

export const MAX_ISO_8601_DATE = new Date('12/31/9999');
